import React from 'react';
import { View, StyleSheet } from 'react-native';

import Bubble from './Bubble';
import SystemMessage from './SystemMessage';
import FlavorMessage from './FlavorMessage';
import Day from './Day';

import { isSameUser, isSameDay } from './utils';

const styles = {
  container: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    marginLeft: 8,
    marginRight: 0,
  },
  left: StyleSheet.create({
    container: {},
  }),
  right: StyleSheet.create({
    container: {},
  }),
};

export default class Message extends React.Component {
  shouldComponentUpdate(nextProps) {
    const next = nextProps.currentMessage;
    const current = this.props.currentMessage;
    const { nextMessage } = this.props;
    const nextPropsMessage = nextProps.nextMessage;
    return (
      next.send !== current.send ||
      next.received !== current.received ||
      next.pending !== current.pending ||
      next.createdAt !== current.createdAt ||
      next.text !== current.text ||
      next.image !== current.image ||
      next.video !== current.video ||
      nextMessage !== nextPropsMessage
    );
  }

  getInnerComponentProps = () => {
    const { containerStyle, ...props } = this.props;
    return {
      ...props,
      isSameUser,
      isSameDay,
    };
  };

  renderDay() {
    if (this.props.currentMessage.createdAt) {
      const dayProps = this.getInnerComponentProps();
      return <Day {...dayProps} />;
    }
    return null;
  }

  renderBubble() {
    const bubbleProps = this.getInnerComponentProps();
    return <Bubble {...bubbleProps} />;
  }

  renderSystemMessage() {
    const systemMessageProps = this.getInnerComponentProps();
    return <SystemMessage {...systemMessageProps} />;
  }

  renderFlavorMessage() {
    const messageProps = this.getInnerComponentProps();
    return <FlavorMessage {...messageProps} />;
  }

  render() {
    let { currentMessage, nextMessage, position, inverted, containerStyle } = this.props;
    const sameUser = isSameUser(currentMessage, nextMessage);

    if (currentMessage.flavor) {
      return this.renderFlavorMessage();
    }

    return (
      <View>
        {this.renderDay()}
        {currentMessage.system ? (
          this.renderSystemMessage()
        ) : (
          <View
            style={[
              styles.container,
              styles[position].container,
              { marginBottom: sameUser ? 2 : 10 },
              !inverted && { marginBottom: 2 },
              containerStyle[position],
            ]}
          >
            {this.props.renderAvatar(this.props)}
            {this.renderBubble()}
          </View>
        )}
      </View>
    );
  }
}

Message.defaultProps = {
  renderAvatar: undefined,
  renderBubble: null,
  position: 'left',
  currentMessage: {},
  nextMessage: {},
  previousMessage: {},
  user: {},
  containerStyle: {},
  inverted: true,
};
